import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-icon-product-prices-tab',
    templateUrl: './icon-product-prices-tab.component.html'
})
export class IconProductPricesTabComponent implements OnInit {

    @Input() cssClass = '';

    constructor() { }

    ngOnInit() {
    }

}
